import { render, staticRenderFns } from "./Scripting.vue?vue&type=template&id=2dc29494&scoped=true&"
import script from "./Scripting.vue?vue&type=script&lang=js&"
export * from "./Scripting.vue?vue&type=script&lang=js&"
import style0 from "./Scripting.vue?vue&type=style&index=0&id=2dc29494&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc29494",
  null
  
)

component.options.__file = "Scripting.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VAvatar } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {
  VAlert,
  VAvatar,
  VBtn,
  VCard,
  VCardActions,
  VCardTitle,
  VChip,
  VContainer,
  VDialog,
  VFlex,
  VIcon,
  VLayout,
  VSpacer,
  VTextarea,
})
